import { Injectable } from '@angular/core';
import { isEqual } from 'lodash-es';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { sortByName } from '@nimbus-global/features/call-as/utils';
import { IAuthenticationService } from '@nimbus-library/features/authentication/services/i-authentication.service';
import { AgentAssistantMapper } from '@nimbus-library/features/agent-assistant/services/mapper/agent-assistant.mapper';
import {
  AgentAssistantAcwViewModel,
  IUserResponsibilityProfile,
} from '@nimbus-library/features/agent-assistant/models/agent-assistant.model';
import { ReportingUserSessionsService } from '@nimbus-global/features/reportingLiveData/reporting-user-sessions.service';
import { AgentAssistantApiClient } from './api/agent-assistant.api-client';

@Injectable({ providedIn: 'root' })
export class AgentAssistantService {
  private readonly agentAssistantMapper: AgentAssistantMapper = new AgentAssistantMapper();

  public constructor(
    private readonly agentAssistantApiClient: AgentAssistantApiClient,
    private readonly authenticationService: IAuthenticationService,
    private readonly reportingUserSessionsService: ReportingUserSessionsService,
  ) {}

  public getAfterCallWorkState$(): Observable<AgentAssistantAcwViewModel | undefined> {
    return this.reportingUserSessionsService.getUserSessionLiveInAcw$().pipe(
      map((session) => (session ? this.agentAssistantMapper.mapAcwSession(session) : undefined)),
      distinctUntilChanged(isEqual),
    );
  }

  public getUserResponsibilityProfiles$(): Observable<IUserResponsibilityProfile[]> {
    const user = this.authenticationService.getUserInfo();
    return this.agentAssistantApiClient.getUserResponsibilityProfiles(user.userId).pipe(map((x) => x.sort((a, b) => sortByName(a, b))));
  }

  public setUserResponsibilityProfile(responsibilityProfileId: string): Observable<boolean> {
    const user = this.authenticationService.getUserInfo();
    return this.agentAssistantApiClient.setUserResponsibilityProfile(user.userId, responsibilityProfileId);
  }
}
